export enum CHAT_PROMT_ROLES {
    SYSTEM = 'system',
    USER = 'user',
    ASSISTANT = 'assistant',
}

export enum AI_CHAT_MODES {
    GRAPHIC = 'graphic',
    NEWS = 'news',
}

export const AiChatModeDescription = {
    [AI_CHAT_MODES.GRAPHIC]: {
        label: 'Создание графики',
        description: 'Создать визуал для готовой новости',
        chip: 'Активировать режим новостей',
        headline: 'Нужна графика для новости?',
        placeholder: 'Введите текст новости',
    },
    [AI_CHAT_MODES.NEWS]: {
        label: 'Создание новости',
        description: 'Сгенерировать новость по теме или ссылке',
        chip: 'Активировать режим графики',
        headline: 'Нужна готовая новость?',
        placeholder: 'Введите тему новости или ссылку на неё',
    },
};

export enum AI_CHAT_JOB_STATUS {
    PENDING = 'pending', // задача создана и ждёт обработки
    RUNNING = 'running', // задача выполняется
    DONE = 'done', // задача успешно завершена
    FAILED = 'failed', // задача упала
    CANCELED = 'canceled', // задача отменена
}
